import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { observable } from 'mobx';

import './App.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

/** Components */
import Main from './containers/main';
import Clients from './containers/client';

const appState = observable({
  amountIncomes: 0
});

appState.increment = function(amount) {
  this.amountIncomes += amount;
};

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div>Cargando...</div>}>
          <Switch>
            <Route exact path="/" component={Main} />
            <Route exact path="/clients" component={Clients} />
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
